import React, { createContext, useState, useContext, useEffect, useCallback, useMemo } from 'react';
import authService from '../services/authService';

const AuthContext = createContext({});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      if (authService.isAuthenticated()) {
        const response = await authService.getCurrentAdmin();
        setAdmin(response.data);
        setIsAuthenticated(true);
      }
    } catch (error) {
      authService.logout();
      setIsAuthenticated(false);
      setAdmin(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = useCallback(async (username, password) => {
    const response = await authService.login(username, password);
    setIsAuthenticated(true);
    await checkAuth();
    return response;
  }, [checkAuth]);

  const logout = useCallback(() => {
    authService.logout();
    setIsAuthenticated(false);
    setAdmin(null);
  }, []);

  const register = useCallback(async (username, email, password) => {
    return await authService.register(username, email, password);
  }, []);

  const contextValue = useMemo(() => ({
    isAuthenticated, admin, login, logout, register, loading
  }), [isAuthenticated, admin, login, logout, register, loading]);

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
};